import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TopBar from './components/layout/TopBar';
import Navbar from './components/layout/Navbar';
import LandingPage from './components/pages/LandingPage';
import EnrollmentPage from './components/pages/EnrollmentPage';
import OurEducators from './components/pages/OurEducators';
import AdminStaff from './components/pages/AdminStaff';
import Classrooms from './components/pages/Classrooms';
import Environment from './components/pages/Environment';
import HomeMadeMeals from './components/pages/HomeMadeMeals';
import TeachingMethods from './components/pages/TeachingMethods';
import ContactUs from './components/pages/ContactUs';
import Home from './components/pages/Home';
import ApplicationForm from './components/pages/ApplicationForm';
import ParentDirect from './components/pages/ParentDirect';
import StaffPortal from './components/pages/StaffPortal';
import PhotoGallery from './components/pages/PhotoGallery';
import Calendar from './components/pages/Calendar';

function App() {
  return (
    <Router>
      <div className="App">
        <TopBar />
        <Navbar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<LandingPage />} />
          <Route path="/about" element={<LandingPage />} />
          <Route path="/about/educators" element={<OurEducators />} />
          <Route path="/about/admin-staff" element={<AdminStaff />} />
          <Route path="/about/classrooms" element={<Classrooms />} />
          <Route path="/about/environment" element={<Environment />} />
          <Route path="/about/home-made-meals" element={<HomeMadeMeals />} />
          <Route path="/about/teaching-methods" element={<TeachingMethods />} />
          <Route path="/enrollment" element={<EnrollmentPage />} />
          <Route path="/our-staff" element={<OurEducators />} />
          <Route path="/gallery" element={<PhotoGallery />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/application" element={<ApplicationForm />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/parentdirect" element={<ParentDirect />} />
          <Route path="/staff" element={<StaffPortal />} />
          <Route path="/original" element={<Home />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
